var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretCollapse = function SvgCaretCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2CC9",
    fillRule: "evenodd",
    d: "M15 1.5C7.544 1.5 1.5 7.544 1.5 15S7.544 28.5 15 28.5 28.5 22.456 28.5 15 22.456 1.5 15 1.5M15 0C6.716 0 0 6.716 0 15s6.716 15 15 15 15-6.716 15-15S23.284 0 15 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2CC9",
    fillRule: "evenodd",
    d: "M21.772 17.766a.763.763 0 0 1-1.1 0L15 11.93l-5.672 5.835a.763.763 0 0 1-1.1 0 .816.816 0 0 1 0-1.132l6.222-6.4a.763.763 0 0 1 1.1 0l6.222 6.4a.816.816 0 0 1 0 1.132",
    clipRule: "evenodd"
  })));
};
export default SvgCaretCollapse;